import {
  LOADING_PROJECT,
  LOADING_ROUTES_LIST,
  LOADING_IMPORT,
  LOADING_UNSCHEDULED,
  LOADING_EDIT_STOP,
  SET_VEHICLES_LIST_LOADED,
  SET_DRIVERS_LIST_LOADED,
  RESET_ACCOUNT_STATE,
  LOADING_PROJECT_INITIAL,
  SET_DETERMINATE_LOADING,
  SET_TAGS_LIST_LOADED,
  SET_TEMPLATES_LIST_LOADED
} from "../actions/types";

const initialState = {
  project: false,
  projectInitial: false,
  routesList: false,
  importPage: false,
  unscheduled: false,
  editStop: false,
  vehiclesListLoaded: false,
  driversListLoaded: false,
  tagsListLoaded: false,
  templatesListLoaded: false,
  determinateLoading: {
    percent: 0,
    loading: false
  }
};

export function loadingReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING_PROJECT:
      return {
        ...state,
        project: action.val
      };
    case LOADING_PROJECT_INITIAL:
      return {
        ...state,
        projectInitial: action.val
      };
    case SET_DETERMINATE_LOADING:
      return {
        ...state,
        determinateLoading: action.obj
      };
    case LOADING_ROUTES_LIST:
      return {
        ...state,
        routesList: action.val
      };
    case LOADING_IMPORT:
      return {
        ...state,
        importPage: action.val
      };
    case LOADING_UNSCHEDULED:
      return {
        ...state,
        unscheduled: action.val
      };
    case LOADING_EDIT_STOP:
      return {
        ...state,
        editStop: action.val
      };
    case SET_TAGS_LIST_LOADED:
      return {
        ...state,
        tagsListLoaded: true
      };
    case SET_TEMPLATES_LIST_LOADED:
      return {
        ...state,
        templatesListLoaded: true
      };
    case SET_VEHICLES_LIST_LOADED:
      return {
        ...state,
        vehiclesListLoaded: true
      };
    case SET_DRIVERS_LIST_LOADED:
      return {
        ...state,
        driversListLoaded: true
      };
    case RESET_ACCOUNT_STATE:
      return {
        ...state,
        vehiclesListLoaded: false,
        driversListLoaded: false
      };
    default:
      return state;
  }
}
